import { render } from "./userguide.vue?vue&type=template&id=16efb8d4&scoped=true"
import script from "./userguide.vue?vue&type=script&lang=js"
export * from "./userguide.vue?vue&type=script&lang=js"

import "./userguide.vue?vue&type=style&index=0&id=16efb8d4&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16efb8d4"]])

export default __exports__